import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Collapse} from 'react-collapse';
import {Alert, Form, Input, Space} from 'antd';
import {StyledApprovalModal} from './StyledApprovalModal';
import SpinSmall from '../../../SpinSmall';
import {formHelpers} from '../../../../utils/helpers';
import {CheckIcon, CloseIcon} from '../../../../icons';

const {Item} = Form;

const defaultFormValues = { comment: '' };

const ApprovalModal = ({
  handleOk,
  handleCancel,
  loading = false,
  mode = 'approve',
  name = '',
  open,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'budgets']);
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const comment = Form.useWatch('comment', {form});

  const trans = (key, props) => t(`budgets:modal.approvalStep.${key}`, props);

  const handleAfterClose = () => {
    form.resetFields();
    if (error) setError(null);
  }

  const handleSubmit = (data) => {
    handleOk?.({
      data,
      errorCallback: (response) => formHelpers.handleFormErrors({form, t, setError, response})
    });
  }

  return (
    <StyledApprovalModal
      afterClose={handleAfterClose}
      cancelButtonProps={{size: 'middle'}}
      forceRender
      okButtonProps={{
        icon: mode === 'reject' ? <CloseIcon /> : <CheckIcon />,
        disabled: comment === '',
        size: 'middle',
        type: 'primary',
      }}
      okText={t(mode)}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      open={open}
      width={400}
      {...rest}
    >
      <SpinSmall spinning={loading}>
        <Space size='middle' direction='vertical' className='w-100'>
          <Space size='small' className='w-100' direction='vertical'>
            <p className='mb-0'>{trans('question', { action: mode })} <span className='fw-700'>{name}</span>?</p>
          </Space>
          <Form
            initialValues={defaultFormValues}
            form={form}
            layout='vertical'
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Item
              label={t('Note')}
              name='comment'
              rules={[{required: true, message: t('validation.fieldIsRequired')}]}
              required
            >
              <Input.TextArea
                placeholder={trans('commentPlaceholder')}
                size='large'
                rows={4}
                style={{ height: 100 }}
              />
            </Item>
          </Form>
        </Space>
        <Collapse isOpened={Boolean(error)}>
          <Alert message={error} type='error' showIcon />
        </Collapse>
      </SpinSmall>
    </StyledApprovalModal>
  );
}

ApprovalModal.propTypes = {
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['approve', 'reject']),
  name: PropTypes.string,
  open: PropTypes.bool.isRequired,
}

export default ApprovalModal;
